import React from "react";
import classNames from "classnames";

function ItineraryInfoCard(props) {
    const { title, days, stops, distance, travelType, isGreen, checked, value, onChange } = props;
    const selectable = !!onChange;
    return (
        <label
            className={classNames("trpr-itinerary-info-card", {
                "trpr-itinerary-info-card--green": isGreen,
                "trpr-itinerary-info-card--selectable": selectable,
                "trpr-itinerary-info-card--selected": checked,
            })}
        >
            {selectable && (
                <input type="radio" checked={checked} value={value} onChange={onChange} name="trpr-itinerary" />
            )}
            <div className="trpr-itinerary-info-card__content">
                <span className="trpr-itinerary-info-card__title">{title}</span>
                <div className="trpr-itinerary-info-card__data">
                    <ul>
                        <li>{days} days</li>
                        <li>{stops} stops</li>
                        <li>{distance} km</li>
                    </ul>
                </div>
            </div>
            {travelType && <span className="trpr-itinerary-info-card__tag">{travelType}</span>}
        </label>
    );
}

ItineraryInfoCard.defaultProps = {
    distance: 0,
    days: 0,
};

export default ItineraryInfoCard;
